import { render, staticRenderFns } from "./QuizCreator.vue?vue&type=template&id=6ead0fce&"
import script from "./QuizCreator.vue?vue&type=script&lang=js&"
export * from "./QuizCreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports